import { createContext, useContext, useState } from "react"

const StyleContext = createContext()

export function useStyle() {
    const context = useContext(StyleContext)
    if(context === undefined){
        throw new Error('useStyle must be used within a StyleProvider')
    }
    return context
}

export function StyleProvider({children}) {
    const [style, setStyle] = useState({
        'node_min_size': 10,
        'node_max_size': 40,
        'node_theme': 'color'
    })
    const value = {style, setStyle}
    return <StyleContext.Provider value={value}>{children}</StyleContext.Provider>
}